
import { useState } from 'react';
import { ImportResult } from "@/services/imports/importTypes";
import { 
  handleExcelUpload as excelUpload, 
  handleMarkdownUpload as markdownUpload,
  downloadTemplateFile as downloadTemplate,
  downloadMarkdownTemplate as downloadMdTemplate
} from "@/components/admin/ImportFunctions";

export const useImportManagement = (userId: string, fetchPendingPrompts: () => void) => {
  const [isImporting, setIsImporting] = useState(false);
  const [isImportingMarkdown, setIsImportingMarkdown] = useState(false);
  const [importStats, setImportStats] = useState<ImportResult | null>(null);

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) return;
    
    const file = e.target.files[0];
    const fileType = file.name.split('.').pop()?.toLowerCase();
    
    if (fileType === 'md' || fileType === 'txt') {
      await handleMarkdownUpload(file);
    } else if (fileType === 'xlsx' || fileType === 'xls' || fileType === 'csv') {
      await handleExcelUpload(file);
    } else {
      throw new Error("Unsupported file type");
    }
    
    e.target.value = '';
  };

  const handleExcelUpload = async (file: File) => {
    await excelUpload(file, userId, setIsImporting, setImportStats);
  };

  const handleMarkdownUpload = async (file: File) => {
    await markdownUpload(file, userId, setIsImportingMarkdown, setImportStats, fetchPendingPrompts);
  };

  const downloadTemplateFile = () => {
    downloadTemplate();
  };

  const downloadMarkdownTemplate = () => {
    downloadMdTemplate();
  };

  return {
    isImporting,
    isImportingMarkdown,
    importStats,
    handleFileUpload,
    downloadTemplateFile,
    downloadMarkdownTemplate
  };
};
